
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import PuzzleChallenge, { PuzzlePayload, } from "@/modules/puzzles/PuzzleChallenge";
const FALLBACK_INITIAL_PUZZLE: PuzzlePayload = {
    puzzleId: "BRhod",
    fen: "4R3/p6k/8/3B3p/1PP2bpK/2BR4/P4r2/7q w - - 0 36",
    moves: "d5h1 f2h2 d3h3 h2h3",
    rating: 806,
    userElo: 800,
    gameNr: 0,
    leagueName: "",
    solvedCount: 0,
    points: 0,
    cleanSolveStreak: 0,
    rank: null,
    nextRank: null,
    nextRankPoints: null,
};
async function getStaticProps() {
    return {
        props: {
            initialPuzzle: FALLBACK_INITIAL_PUZZLE,
        },
        revalidate: 86400,
    };
}
export default PuzzleChallenge;

    async function __Next_Translate__getStaticProps__19f159bc1aa__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19f159bc1aa__ as getStaticProps }
  